@if (!(sharedDataService.progressBarHidden$ | async)) {
  <mat-progress-bar mode="indeterminate"
  color="warn"></mat-progress-bar>
}

<div class="app-container">
  <div class="router-outlet-container" [ngClass]="{ 'mobile-router-outlet-container': (sharedDataService.isHandset$ | async)}">
    <router-outlet></router-outlet>
  </div>
  <app-bottom-bar></app-bottom-bar>
</div>